import adserveEventFilters from './adverse-event';

const initFilters = {};

initFilters.install = (Vue) => {
  adserveEventFilters(Vue);
};

export default initFilters;
